import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { MongoDbLinkedService } from 'app/model/linkedservice/mongo-db.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MongoDbLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                server: '*',
                port: '*',
                databaseName: '*',
                authenticationType: '*',
                username: '*',
                password: 'secret',
                authSource: '*',
                enableSsl: '*',
                allowSelfSignedServerCert: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class MongoDbLinkedServiceAdapter extends LinkedServiceAdapter<MongoDbLinkedService> {
    protected modelConstructor(): new () => MongoDbLinkedService {
        return MongoDbLinkedService;
    }

    protected model(): IModel {
        return MongoDbLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: MongoDbLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.MongoDbLinkedService;

        properties.type = Metamodel.modelFor(MongoDbLinkedService).name;
        properties.typeProperties = {
            server: linkedService.serverName,
            port: linkedService.port,
            databaseName: linkedService.databaseName,
            authenticationType: linkedService.authenticationType,
            username: linkedService.userName,
            password: passwordOrAKVtoSecretBase(linkedService.password, this.context),
            authSource: linkedService.authSource,
            enableSsl: linkedService.enableSsl,
            allowSelfSignedServerCert: linkedService.allowSelfSignedServerCert
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: MongoDbLinkedService): Promise<MongoDbLinkedService> {
        const prop = linkedServiceResource.properties as Model.MongoDbLinkedService;
        linkedService.serverName = prop.typeProperties.server;
        linkedService.port = prop.typeProperties.port;
        linkedService.databaseName = prop.typeProperties.databaseName;
        linkedService.authenticationType = prop.typeProperties.authenticationType;
        linkedService.userName = prop.typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(prop.typeProperties.password, prop.typeProperties.authenticationType === 'Basic', this.context);
        linkedService.authSource = prop.typeProperties.authSource;
        linkedService.enableSsl = prop.typeProperties.enableSsl;
        linkedService.allowSelfSignedServerCert = prop.typeProperties.allowSelfSignedServerCert;
        return linkedService;
    }
}
